import { Injectable, signal } from '@angular/core';
import { MFA_CONST } from '@assets/const/mfa.const';
import { MFAModes } from '../enums/enums/mfa-modes.enum';

@Injectable({
  providedIn: 'root'
})
export class MfaOptInService {
  private readonly hasMFAError = signal<boolean>(false);

  redirectToMFAFlow(
    mfaDomain: string,
    mfaState: string,
    mfaMode: number
  ): void {
    if (
      this.checkParamsValidity(mfaDomain) &&
      this.checkParamsValidity(mfaState)
    ) {
      const mfaFlowURL = `https://${mfaDomain}/continue?state=${mfaState}&MFA=${mfaMode}`;
      if (mfaMode === MFAModes.SKIP) {
        // Skip Flag for the current browser tab and for other browser tabs
        localStorage.setItem(MFA_CONST.MFA_SKIP, new Date().toDateString());
      }
      window.location.href = mfaFlowURL;
    } else {
      this.hasMFAError.set(true);
    }
  }

  userHasSkippedMFA(): boolean {
    const mfaSkippedDate = localStorage.getItem(MFA_CONST.MFA_SKIP);
    const currentDate = new Date().toDateString();
    const isMFASkipValid = mfaSkippedDate === currentDate.toString();

    return isMFASkipValid;
  }

  checkParamsValidity(value?: string | null): boolean {
    return !!value?.trim();
  }

  resetMFAError() {
    this.hasMFAError.set(false);
  }

  getHasMFAError() {
    return this.hasMFAError;
  }
}
